export const data = {
    subtitle: 'Pobierz aplikację <br />i obsługuj swoje konto',
    info: 'ocena zadowolonych użytkowników',
}
